// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDownCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PDownCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PDownCircleOutlined = function PDownCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDownCircleOutlinedSvg
  }));
};

PDownCircleOutlined.displayName = 'PDownCircleOutlined';
export default React.forwardRef(PDownCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDownCircleOutlined.js
// module id = 3344
// module chunks = 0